import { MantineTheme } from '@mantine/core';

export const getPanelWrapperWidthStyles = (theme: MantineTheme) => ({
  width: '100%',
  maxWidth:
    Math.floor(theme.other.layoutSizes.containerWidth / 2) -
    theme.other.spacing(1),
});
